module.exports = __webpack_public_path__ + "static/media/password.e7b22402.svg";